import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import axios from 'axios'
import { STRAPI_URL } from './config'

// Create axios instance for Strapi API
const httpInstance = axios.create({
  baseURL: `${STRAPI_URL}/api`,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
httpInstance.interceptors.request.use(
  (config) => {
    // Add any auth tokens here if needed
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Response interceptor
httpInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // Handle common errors here
    // console.log(new Error().stack)
    console.error('HTTP Error:', JSON.stringify(error, null, 2))
    return Promise.reject(error)
  },
)

// Generic GET request function
export async function getRequest<T>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
  return httpInstance.get<T>(url, config)
}

// Generic POST request function
export async function postRequest<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
  return httpInstance.post<T>(url, data, config)
}

// Generic PUT request function
export async function putRequest<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
  return httpInstance.put<T>(url, data, config)
}

// Generic DELETE request function
export async function deleteRequest<T>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
  return httpInstance.delete<T>(url, config)
}

export default httpInstance
